<template>
  <el-dialog
    title="开票导入记录"
    :visible="visible"
    width="60%"
    @close="$emit('update:visible', false)"
  >
    <el-table :data="dataList">
      <el-table-column label="导入时间" prop="importDate" width="200" align="center">
        <template v-slot="{ row }">
          <div>{{ row.importDate | formatTime('{y}-{M}-{d} {h}:{m}:{s}') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作人" prop="userName" align="center"></el-table-column>
      <el-table-column label="源文件" prop="fileKey" align="center" width="150">
        <template v-slot="{ row }">
          <el-button type="text" @click="downloadFile(row.fileKey, row.fileName)">{{
            row.fileName ? row.fileName : '下载'
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="导入状态" prop="status" align="center">
        <template v-slot="{ row }">
          <div>{{ row.status | convertStatus }}</div>
        </template>
      </el-table-column>
      <el-table-column label="导入结果" align="center" width="200">
        <template v-slot="{ row }">
          <div>成功条数：{{ row.successCount }}</div>
          <div>
            失败条数：<span v-if="row.failedCount === 0">0</span>
            <el-button
              v-else
              type="text"
              @click="downloadFile(row.resultFileKey, row.resultFileName)"
              >{{ row.failedCount }}</el-button
            >
          </div>
          <div v-if="row.remark" class="c-red">
            {{ row.remark }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="page"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-size="pageSize"
      :page-sizes="[5, 10, 20, 30, 50]"
      :total="totalNum"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </el-dialog>
</template>

<script>
import { FILE_ACCESS_PRIVATE } from '@/common/constants/index'
import { getWebToken } from '@/common/utils/common'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    convertStatus(status) {
      let statuses = {
        '1': '初始化',
        '2': '校验中',
        '3': '解析中',
        '4': '解析完成'
      }
      return statuses[status] ? statuses[status] : ''
    }
  },
  data() {
    return {
      dataList: [],
      pageSize: 5,
      pageNum: 1,
      totalNum: 0
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadData()
      }
    }
  },
  methods: {
    async loadData() {
      let { success, data } = await this.$post('invoice.seller.queryImportInvoiceLog', {
        request: {
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
      if (success) {
        // todo 数据类型未更新
        this.dataList = data[0].list
        this.totalNum = data[0].totalNum
      }
    },
    downloadFile(key, name) {
      try {
        let downloadElement = document.createElement('a')
        downloadElement.download = name
        downloadElement.href = `${FILE_ACCESS_PRIVATE}${key}&_tk=${getWebToken()}`
        document.body.appendChild(downloadElement)
        downloadElement.click()
        console.log(downloadElement)
        document.body.removeChild(downloadElement)
      } catch (err) {
        console.log(err)
      }
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.loadData()
    },
    handleCurrentChange(pageNo) {
      this.pageNum = pageNo
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  text-align: right;
  margin-top: 20px;
}
</style>
